module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/tv-h5.1ab1f2bb.png";